import React from "react";
import { FaClock, FaSignOutAlt } from "react-icons/fa";
import { useAuth } from "react-oidc-context";
import { signOutRedirect } from "../CognitoConfig";
import "../styles/PendingAccessView.css";

const PendingAccessView = () => {
  const auth = useAuth();

  const email =
    auth.user?.profile?.email ||
    auth.user?.profile?.name ||
    auth.user?.profile?.preferred_username ||
    "Usuario corporativo";

  const handleLogout = () => {
    auth.removeUser();
    signOutRedirect();
  };

  return (
    <div className="pending-access-view">
      <div className="pending-access-card">
        <div className="pending-access-icon">
          <FaClock />
        </div>

        <p className="pending-access-eyebrow">OCESA - GAIA</p>

        <h1>Acceso pendiente de activación</h1>

        <p className="pending-access-text">
          Tu cuenta corporativa fue validada correctamente, pero todavía no tiene
          permisos asignados dentro de GAIA.
        </p>

        <div className="pending-access-user">
          <span>Usuario detectado</span>
          <strong>{email}</strong>
        </div>

        <p className="pending-access-help">
          Un administrador debe asignarte el rol correspondiente. Después de que
          se asignen tus permisos, cierra sesión y vuelve a ingresar.
        </p>

        <button className="pending-access-button" onClick={handleLogout}>
          <FaSignOutAlt />
          Cerrar sesión
        </button>
      </div>
    </div>
  );
};

export default PendingAccessView;
